import { useCallback, useEffect, useMemo } from 'react';
import useGetDetailActiveApp from '../../pages/EditCarriersPage/useGetDetailActiveApp';

export interface ShippingMethodOption {
  code: string;
  name: string;
  displayName: string;
  enabled: boolean;
}

interface UseShippingMethodsOptionsReturn {
  methods: ShippingMethodOption[];
  isLoading: boolean;
  isError: boolean;
  fetchMethods: () => void;
}

export function useShippingMethodsOptions(
  carrierId: string,
): UseShippingMethodsOptionsReturn {
  const { detailActiveApp, isLoading, isError, fetchDetailActiveApp } =
    useGetDetailActiveApp();

  useEffect(() => {
    if (carrierId) {
      fetchDetailActiveApp(carrierId);
    }
  }, [carrierId, fetchDetailActiveApp]);

  const methods = useMemo<ShippingMethodOption[]>(() => {
    if (!detailActiveApp?.options) return [];

    return Object.entries(detailActiveApp.options)
      .map(([code, config]) => ({
        code,
        name: config.optionName,
        displayName: `${detailActiveApp.name} - ${config.optionName}`,
        enabled: config.isEnabled,
      }))
      .filter((method) => method.enabled);
  }, [detailActiveApp]);

  const fetchMethods = useCallback(() => {
    if (carrierId) {
      fetchDetailActiveApp(carrierId);
    }
  }, [carrierId, fetchDetailActiveApp]);

  return {
    methods,
    isLoading,
    isError,
    fetchMethods,
  };
}

export default useShippingMethodsOptions;
